import { getAuth } from "firebase/auth";

async function postJson(url, body) {
  const auth = getAuth();
  const user = auth.currentUser;

  if (!user) {
    throw new Error("You must be signed in");
  }

  const token = await user.getIdToken();

  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(data.error || "Request failed");
  }

  return data;
}

export async function createTenantSubscriptionCheckout(tenantId, planKey) {
  return postJson("/api/createTenantSubscription", { tenantId, planKey });
}

export async function previewTenantSubscriptionPlanChange(tenantId, planKey) {
  return postJson("/api/previewTenantSubscriptionPlanChange", { tenantId, planKey });
}

export async function updateTenantSubscriptionPlan(tenantId, planKey, prorationDate = null) {
  return postJson("/api/updateTenantSubscriptionPlan", { tenantId, planKey, prorationDate });
}

export async function createTenantBillingPortal(tenantId) {
  return postJson("/api/createTenantBillingPortalSession", { tenantId });
}

export async function cancelTenantBilling(tenantId, immediate = false) {
  return postJson("/api/cancelTenantSubscription", { tenantId, immediate });
}
